import { useEffect } from "react";
import { gql, useQuery } from "@apollo/client";
import { FormInstance } from "antd/es/form/hooks/useForm";
import useCurrentUser from "../../hooks/useCurrentUser";

type InvoiceFormQuery = {
  patient: {
    invoice_name: string;
    invoice_surname: string;
    invoice_cod_fiscale: string;
    invoice_address: string;
    invoice_cap: string;
    invoice_city: string;
    invoice_province: string;
    invoice_phone: string;
  };
};

export const GET_INVOICE_FORM_DATA = gql`
  query getInvoiceFormData($id: Int!) {
    patient(id: $id) {
      invoice_name
      invoice_surname
      invoice_cod_fiscale
      invoice_address
      invoice_cap
      invoice_city
      invoice_province
      invoice_phone
    }
  }
`;

const useInvoiceDataForm = ({ form }: { form: FormInstance }) => {
  const { isDoctor, id } = useCurrentUser();

  const {
    data,
    loading
  } = useQuery<InvoiceFormQuery>(GET_INVOICE_FORM_DATA, {
    fetchPolicy: "no-cache",
    variables: {
      id: Number(id)
    },
    skip: !isDoctor && !id
  });

  useEffect(() => {
    if (data && form) {
      form.setFieldsValue({
        invoiceName: data.patient.invoice_name,
        invoiceSurname: data.patient.invoice_surname,
        invoiceCodFisc: data.patient.invoice_cod_fiscale,
        address: data.patient.invoice_address,
        cap: data.patient.invoice_cap,
        city: data.patient.invoice_city,
        province: data.patient.invoice_province,
        phone: {
          number: data.patient.invoice_phone
        }
      });
    }
  }, [data, form]);

  return {
    loading
  };
};

export default useInvoiceDataForm;
